module.exports = __webpack_public_path__ + "static/media/PSIRF_mail_green.880bbe3c.png";